module.exports = __webpack_public_path__ + "26d6d331520d5052baf66bedd81da1e7.svg";